module.exports = __webpack_public_path__ + "static/media/jiaocheliuchengjizhixingbiaozhun.77382edc.png";